import React from 'react'
import MobileHomeParkCalculator from '../pages/Underwriting/MobileHomeCalculator'

export const MOBILE_HOME_UNDERWRITING_PATH = '/mobile-home-underwriting'

export const UNDERWRITING_ROUTES = [
	{
		path: MOBILE_HOME_UNDERWRITING_PATH,
		element: <MobileHomeParkCalculator />,
	},
]
